module.exports = __webpack_public_path__ + "static/media/aws-black-removebg.6d4a78d7.png";